<template>
  <v-select
    v-model="$i18n.locale"
    :items="langs"
    item-text="text"
    item-value="value"
    label="Language"
    :menu-props="{ maxHeight: 400 }"
    >
  </v-select>
</template>

<script>
export default {
  name: 'LanguagePicker',
  data () {
    return {
      langs: [
        { text: 'English', value: 'en' },
        { text: 'German', value: 'de' },
        { text: 'French', value: 'fr' },
        { text: 'Italian', value: 'it' },
        { text: 'Portuguese', value: 'pt' },
        { text: 'Spanish', value: 'es' },
        { text: 'Dutch', value: 'nl' },
      ]
    }
  }
}
</script>
